import axios from 'axios';

import configureSmooch from 'configuration/configureProvider';
import generateSessionFromConversation from 'adapters/converters/fromSmoochConversationToSession';

export default class SmoochChatGateway {
  constructor(smooch) {
    this.smooch = smooch;
  }

  getSession(storedSession) {
    const conversation = this.smooch.getConversation();
    return conversation ? generateSessionFromConversation(conversation, storedSession) : null;
  }

  getSessionId() {
    const conversation = this.smooch.getConversation();
    return conversation ? conversation._id : null;
  }

  async configureProvider(providerId) {
    // we should handle the error here
    await configureSmooch(providerId, this.smooch);
  }

  async auth({ name, email, orgDomain, loginDomain, providerId }) {
    return await axios.post(`${orgDomain}/api/smooch/v1/authenticate`, { name, email, loginDomain, providerId });
  }

  login({ userId, jwt }) {
    return this.smooch.login(userId, jwt); // returns a promise
  }

  async reconnect() {
    return await this.smooch.reconnect();
  }

  registerConnectionCallbacks({ handleConnected, handleDisconnected }) {
    this.smooch.on('connected', handleConnected);
    this.smooch.on('disconnected', handleDisconnected);
  }
}
